
export class AiGeneratedContentModel {
    id: string;
    value: string = '';
    loading: boolean;
    history: string[] = [];
    currentIndex: number;
    aiResponse: string = '';
    placeholder: string;

    constructor(id: string) {
        this.id = id;
        this.placeholder = 'Common.ai.generatedContentCard.valuePlaceholder';
    }
}
